<template>
    <b-modal
        v-model="isOpen"
        size="md"
        :title="title"
        modal-class="vue-need-bootstrap"
        title-class="font-weight-bold"
        lazy
        centered
        @ok="emit('ok')"
        @cancel="emit('cancel')"
        @close="emit('cancel')"
    >
        <slot name="modal-content">
            {{ description }}
        </slot>

        <template #modal-footer="{ ok, cancel }">
            <div class="d-flex justify-content-between w-100">
                <c-button :class="{ invisible: hideCancel }" text="Cancel" variant="secondary" @click="cancel" />
                <c-button :text="actionVerb" variant="primary" @click="ok" />
            </div>
        </template>
    </b-modal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import CButton from '@/components/shared/CButton';

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
    (event: 'ok'): void;
    (event: 'cancel'): void;
}>();

const props = defineProps<{
    value: boolean;
    title?: string;
    description?: string;
    actionVerb: string;
    hideCancel?: boolean;
}>();

const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});
</script>
